import React from 'react'

import { Col, Form } from '_zari/core'

import { PresupuestoNivel3Select2 } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const CodigoPresupuestoFormGroup = ({ iError, iTouched, setFieldValue, iValue }) => {
  const onChange = React.useCallback(
    salida => {
      setFieldValue('codigoPresupuesto', salida.value)
      setFieldValue('infoCodigoPresupuesto', salida.label)

      KeyEventUtil.leaveOnKeyEvent('movimientoPresupuesto-agregar-button')
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('codigoPresupuesto', '')
    setFieldValue('infoCodigoPresupuesto', '')

    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent('movimientoPresupuesto-select2-codigoPresupuesto')
    }, 200)
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='PRESUPUESTO' htmlFor='movimientoPresupuesto-select2-codigoPresupuesto' md={12} />
      <Col md={12}>
        {iValue ? (
          <ClearInputGroup id='movimientoPresupuesto-clear-codigoPresupuesto' iValue={iValue} clickClear={clickClear} />
        ) : (
          <PresupuestoNivel3Select2 id='movimientoPresupuesto-select2-codigoPresupuesto' onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoPresupuestoFormGroup)
